export default __webpack_public_path__ + "static/Elevate100_Certificate-0e7c8c0ba8f6ee6b6739df611d4446bc.jpg";